const Module = {
    namespaced: true,
    state: {
        loading: 0
    },
    mutations: {
        serviceLoading(state) {
            state.loading++;
        },
        serviceFinished(state) {
            if (state.loading > 0) {
                state.loading--;
            }
        }
    },
    getters: {
        isLoading: (state) => state.loading > 0
    },
    actions: {
        startLoading({ commit }) {
            commit("serviceLoading");
        },
        stopLoading({ commit }) {
            commit("serviceFinished");
        }
    }
};

export default Module;
